import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { onMounted, computed } from 'vue'
import { usePromisifyDialog } from '@shared/utils/dialog'


export default /*#__PURE__*/_defineComponent({
  props: {
  duration: {
    type: Number,
    default: 3000,
  },
  message: {
    type: String,
    default: '',
  },
  forward: {
    type: String,
    default: '',
  },
  onclick: {
    type: Function,
    default: () => {},
  },
  type: {
    type: String,
    default: 'info',
  },
},
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const { isShow, close } = usePromisifyDialog(emit)
const visible = computed(() => isShow.value && !!props.message)

const handleOnClick = () => {
  close(null)
  typeof props.onclick === 'function' && props.onclick()
}

onMounted(() => {
  if (props.duration !== 0) setTimeout(() => {
    close(null)
  }, props.duration)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["toast", [_unref(visible) ? 'is-shown' : 'is-hidden']])
    }, [
      _createElementVNode("span", null, [
        _createElementVNode("i", {
          class: _normalizeClass(`icomoon-icon icomoon-${props.type}`)
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(props.message) + " ", 1),
        (props.forward)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: handleOnClick
            }, _toDisplayString(props.forward), 1))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})